import { h } from 'preact';

import Selector from 'components/bolt/quizPhotobooth/selector';

// import s from 'components/bolt/quizPhotobooth/quoteSelector.sss';

export default class QuoteSelector extends Selector {
	constructor(props) {
		super(props);
		this.titleText = props.appData?.copy?.baseCopy?.$QUIZPHOTOBOOTH_CHOOSE_QUOTE;
		this.select(0);
	}

	get quotes() {
		return this.props.cardData.sides.length > 1 ? this.props.quotesDual : this.props.quotesSolo;
	}

	get currentIndex() {
		return this.quotes.indexOf(this.props.cardData.quote);
	}

	get itemsCount() {
		return this.quotes.length;
	}

	onBack() {
		this.setQuote('');
	}

	select(index) {
		this.setQuote(this.quotes[index] || '');
	}

	setQuote(quote) {
		const cardData = { ...this.props.cardData, quote };
		this.props.updateCardData(cardData);
	}
}